import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { SelectOption } from './select.interfaces';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SelectComponent {
  @Input() label: string;

  @Input() name: string;

  @Input() options: SelectOption[];

  @Input() control: FormControl;

  @Input() submitted = false;

  @Output() handleChange = new EventEmitter();

  get errors(): boolean {
    if (this.control) {
      return this.control.invalid && (this.control.dirty || this.control.touched);
    }
  }
}
